import React from 'react';

import { cn } from 'lib/helpers/utility';

import Tag from 'components/shared/Tag/Tag';
import { getTagStyle } from 'components/shared/Tags/lib/tagColorOptions';

// A wrapping pill grows past its fixed height, so it keeps that height as a minimum instead.
const WRAP_MIN_HEIGHT = {
  small: 'min-h-[20px]',
  medium: 'min-h-[24px]',
  large: 'min-h-[28px]'
};

const TagPill = ({ tag, onRemove, className, title, size = 'medium', wrap = false }) => {
  const { border } = getTagStyle(tag?.color);

  return (
    <Tag
      color={tag?.color}
      borderColor={border}
      size={size}
      icon={tag?.important ? 'info-mono' : undefined}
      iconColor="neutral"
      close={!!onRemove}
      onRemove={onRemove}
      removeValue={tag}
      className={cn(wrap && ['h-auto', WRAP_MIN_HEIGHT[size]], className)}
      labelClassName={wrap ? '[overflow-wrap:anywhere]' : undefined}
      truncate={!wrap}
      title={title}>
      {tag?.name}
    </Tag>
  );
};

export default TagPill;
